import { render, staticRenderFns } from "./politicalOutlook.vue?vue&type=template&id=adf9c3a0&"
import script from "./politicalOutlook.vue?vue&type=script&lang=ts&"
export * from "./politicalOutlook.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports